import React from "react";

const HeroSection = () => {
  return (
    <section className="relative w-full px-4 pt-16 lg:pt-32 pb-8 lg:pb-10">
      {/* Container matches the cards container below (max-w-[1200px]) so left edge aligns */}
      <div className="max-w-[1200px] mx-auto">
        <div className="max-w-[640px] lg:pl-7">
          <span
            className="inline-flex items-center gap-2 text-[11px] sm:text-[13px] font-semibold tracking-[0.16em] uppercase mb-3 sm:mb-4"
            style={{ color: "#F26B1F" }}
          >
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#F26B1F]" />
            Trusted by 5,000+ homeowners
          </span>
          <h1 className="font-extrabold text-[#0f172a] tracking-tight text-[34px] sm:text-[52px] lg:text-[64px] leading-[1.05] sm:leading-[1.02]">
            <span className="lg:whitespace-nowrap">Home Renovations</span>
            <br />
            <span style={{ color: "#F26B1F" }}>Done Right.</span>
          </h1>
          <p className="mt-4 sm:mt-5 text-[#475569] text-[14px] sm:text-[17px] leading-[1.55] sm:leading-[1.6] max-w-[560px]">
            Get matched with vetted pros, see your project priced and planned
            upfront, and renovate with total peace of mind. Backed by our{" "}
            <span className="font-semibold text-[#0f172a]">
              Done-Right Guarantee
            </span>
            —payment only releases when the work meets your standards.
          </p>

          {/* Trust micro-points */}
          <ul className="mt-4 sm:mt-5 flex flex-wrap items-center gap-x-5 sm:gap-x-6 gap-y-2 text-[12px] sm:text-[13px] text-[#475569]">
            <li className="flex items-center gap-1.5">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12.5l4 4L19 7" stroke="#1AA0DD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Free, no-obligation quote
            </li>
            <li className="flex items-center gap-1.5">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12.5l4 4L19 7" stroke="#1AA0DD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Vetted local contractors
            </li>
            <li className="flex items-center gap-1.5">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12.5l4 4L19 7" stroke="#1AA0DD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Pay only when satisfied
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
